// HowItWorks.js
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';
import { Link } from 'react-router-dom';

export function HowItWorks() {
  return (
    <div className="page-wrapper">
      <Navbar />
      <div style={{background:'linear-gradient(135deg,#edfaf3,#fff)',padding:'56px 0 40px'}}>
        <div className="container" style={{textAlign:'center'}}>
          <h1>How Budget Tutor works</h1>
          <p style={{maxWidth:520,margin:'12px auto 0',fontSize:'1.05rem'}}>Everything you need to know about booking a lesson or becoming a tutor.</p>
        </div>
      </div>
      <div className="container" style={{padding:'48px 24px'}}>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:40,marginBottom:48}}>
          <div>
            <div style={{background:'#052e1c',color:'#22c97f',borderRadius:12,padding:'4px 14px',display:'inline-block',fontSize:'0.8rem',fontWeight:700,marginBottom:16}}>FOR PARENTS</div>
            <h2 style={{marginBottom:24}}>Finding and booking a tutor</h2>
            {[
              ['1','Create a free account','Sign up in under 2 minutes. No payment needed upfront.'],
              ['2','Top up your wallet','Add money to your secure wallet — minimum £8 or $10.'],
              ['3','Search for tutors','Filter by subject, level, day and DBS status.'],
              ['4','Book a lesson','Pick a slot, add notes, and send the request. Tutor has 24hrs to confirm.'],
              ['5','Attend the lesson','Your tutor shares a Google Meet link via the platform.'],
              ['6','Sign off & review','Confirm the lesson went ahead, leave a rating, and payment is released.'],
            ].map(([n,title,desc])=>(
              <div key={n} style={{display:'flex',gap:16,marginBottom:20}}>
                <div style={{width:32,height:32,borderRadius:'50%',background:'linear-gradient(135deg,#22c97f,#0d6e4f)',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:800,color:'#fff',fontSize:'0.85rem',flexShrink:0}}>{n}</div>
                <div>
                  <strong style={{fontSize:'0.95rem',display:'block',marginBottom:3}}>{title}</strong>
                  <p style={{margin:0,fontSize:'0.875rem'}}>{desc}</p>
                </div>
              </div>
            ))}
            <Link to="/register/parent" className="btn btn-primary" style={{marginTop:8}}>Get started as a parent</Link>
          </div>
          <div>
            <div style={{background:'#edfaf3',color:'#0a4a35',borderRadius:12,padding:'4px 14px',display:'inline-block',fontSize:'0.8rem',fontWeight:700,marginBottom:16}}>FOR TUTORS</div>
            <h2 style={{marginBottom:24}}>Joining as a tutor</h2>
            {[
              ['1','Create your account','Register and pay the one-off £1/$1 platform access fee.'],
              ['2','Pass our checks','Submit ID, English language video, DBS info and two references.'],
              ['3','Set your profile','Add your bio, subjects, levels and availability.'],
              ['4','Get approved','Our team reviews your application within 48 hours.'],
              ['5','Start teaching','Accept booking requests and teach via Google Meet.'],
              ['6','Get paid monthly','Earnings paid end of each month if balance is £25+/$30+.'],
            ].map(([n,title,desc])=>(
              <div key={n} style={{display:'flex',gap:16,marginBottom:20}}>
                <div style={{width:32,height:32,borderRadius:'50%',background:'#edfaf3',border:'2px solid #22c97f',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:800,color:'#0d6e4f',fontSize:'0.85rem',flexShrink:0}}>{n}</div>
                <div>
                  <strong style={{fontSize:'0.95rem',display:'block',marginBottom:3}}>{title}</strong>
                  <p style={{margin:0,fontSize:'0.875rem'}}>{desc}</p>
                </div>
              </div>
            ))}
            <Link to="/become-a-tutor" className="btn btn-secondary" style={{marginTop:8}}>Become a tutor</Link>
          </div>
        </div>
        <div className="card" style={{background:'var(--green-50)',border:'1.5px solid var(--green-200)',padding:28,textAlign:'center'}}>
          <h3 style={{marginBottom:8}}>Transparent pricing — always</h3>
          <p style={{margin:'0 auto',maxWidth:480}}>Parents pay <strong>£8/hr or $10/hr</strong>. Tutors receive <strong>£4/hr or $5/hr</strong>. The platform keeps the rest to maintain and improve the service. No hidden charges.</p>
        </div>
      </div>
      <Footer />
      <style>{`@media(max-width:768px){div[style*="grid-template-columns: 1fr 1fr"]{grid-template-columns:1fr!important}}`}</style>
    </div>
  );
}

export function BecomeTutor() {
  return (
    <div className="page-wrapper">
      <Navbar />
      <div style={{background:'linear-gradient(135deg,#052e1c,#0a4a35)',padding:'64px 0'}}>
        <div className="container" style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:40,alignItems:'center'}}>
          <div>
            <div style={{background:'rgba(34,201,127,0.15)',color:'#22c97f',borderRadius:12,padding:'4px 14px',display:'inline-block',fontSize:'0.82rem',fontWeight:700,marginBottom:20}}>BECOME A TUTOR</div>
            <h1 style={{color:'#fff',marginBottom:16}}>Earn by teaching what you know</h1>
            <p style={{color:'rgba(255,255,255,0.7)',fontSize:'1rem',marginBottom:28}}>Set your own schedule. Earn £4/hr ($5/hr) for every lesson. One small platform fee — then keep earning.</p>
            <Link to="/register/tutor" className="btn btn-primary btn-lg">Apply now — £1 access fee</Link>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
            {[['£4/hr','You earn per lesson'],['£1','One-off fee to join'],['48hrs','Typical approval time'],['Monthly','Automatic payouts']].map(([val,label])=>(
              <div key={label} style={{background:'rgba(255,255,255,0.06)',borderRadius:12,padding:'20px 18px',border:'1px solid rgba(255,255,255,0.1)'}}>
                <div style={{fontSize:'1.5rem',fontWeight:800,color:'#22c97f'}}>{val}</div>
                <div style={{fontSize:'0.8rem',color:'rgba(255,255,255,0.6)',marginTop:4}}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="container" style={{padding:'48px 24px'}}>
        <h2 style={{textAlign:'center',marginBottom:32}}>What we look for</h2>
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))',gap:20,marginBottom:40}}>
          {[
            ['🎓','Qualifications','Relevant degree or professional experience in your subject area.'],
            ['🗣️','Clear English','You\'ll record a short 30-second video to demonstrate communication.'],
            ['🪪','Valid ID','Passport, driving licence or national ID — verified by our team.'],
            ['📋','Two references','Professional or academic references. We\'ll review them.'],
          ].map(([icon,title,desc])=>(
            <div key={title} className="card" style={{textAlign:'center',padding:24}}>
              <div style={{fontSize:'2rem',marginBottom:12}}>{icon}</div>
              <h3 style={{fontSize:'0.95rem',marginBottom:8}}>{title}</h3>
              <p style={{margin:0,fontSize:'0.82rem'}}>{desc}</p>
            </div>
          ))}
        </div>
        <div style={{textAlign:'center'}}>
          <Link to="/register/tutor" className="btn btn-primary btn-lg">Start your application</Link>
        </div>
      </div>
      <Footer />
      <style>{`@media(max-width:768px){div[style*="grid-template-columns: 1fr 1fr"]{grid-template-columns:1fr!important}}`}</style>
    </div>
  );
}

export function Terms() {
  return (
    <div className="page-wrapper">
      <Navbar />
      <div className="container-sm" style={{padding:'48px 24px'}}>
        <h1 style={{marginBottom:8}}>Terms of Service</h1>
        <p style={{color:'var(--ink-400)',marginBottom:32}}>Last updated: January 2024</p>
        {[
          ['1. The platform','BudgetTutor acts as an introducer only between parents/guardians ("Clients") and tutors. We do not employ tutors, host lessons, or guarantee outcomes.'],
          ['2. Platform access fee','Tutors pay a one-off, non-refundable £1 (GBP) or $1 (USD) fee to access the platform. This fee is charged once and covers the cost of our vetting process.'],
          ['3. Lesson fees','Clients pay £8/hr (GBP) or $10/hr (USD) per lesson. Tutors receive £4/hr (GBP) or $5/hr (USD). The remainder is retained by BudgetTutor as a platform fee.'],
          ['4. Cancellation policy','If a tutor cancels, the client receives a full refund to their wallet. If a client cancels, no refund is issued. Refund decisions for suspended tutors are made by our admin team on a case-by-case basis.'],
          ['5. Payment release','Clients are asked to sign off lessons after they occur. If no action is taken within 7 days of the scheduled lesson, payment is automatically released to the tutor.'],
          ['6. Disputes','Disputes must be raised within 7 days of the lesson. Our team will review and resolve at their discretion.'],
          ['7. Safeguarding','All tutors are manually vetted. DBS status is displayed but not mandatory. Contact information must not be shared via the platform messaging system.'],
          ['8. Payouts','Tutor payouts occur monthly on the 1st. Minimum payout threshold is £25 (GBP) or $30 (USD). Balances below the threshold roll over.'],
        ].map(([title,body])=>(
          <div key={title} style={{marginBottom:24,paddingBottom:24,borderBottom:'1px solid var(--ink-100)'}}>
            <h3 style={{marginBottom:8,color:'var(--green-800)'}}>{title}</h3>
            <p style={{margin:0}}>{body}</p>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
}

export function Privacy() {
  return (
    <div className="page-wrapper">
      <Navbar />
      <div className="container-sm" style={{padding:'48px 24px'}}>
        <h1 style={{marginBottom:8}}>Privacy Policy</h1>
        <p style={{color:'var(--ink-400)',marginBottom:32}}>Last updated: January 2024</p>
        {[
          ['What data we collect','We collect name, email, phone number, country, and payment information. Tutors also provide ID documents, DBS certificates, and reference information.'],
          ['How we use your data','To operate the platform, process payments via Stripe, match tutors with clients, and send transactional notifications (when enabled).'],
          ['Data storage','All data is stored securely on servers in the UK/EU. Payment data is handled by Stripe and not stored on our servers.'],
          ['Your rights','You have the right to access, correct, or delete your personal data at any time. Contact us to exercise these rights.'],
          ['Cookies','We use session cookies for authentication only. We do not use tracking or advertising cookies.'],
          ['Third parties','We use Stripe for payment processing. We do not sell your data to third parties.'],
        ].map(([title,body])=>(
          <div key={title} style={{marginBottom:24,paddingBottom:24,borderBottom:'1px solid var(--ink-100)'}}>
            <h3 style={{marginBottom:8,color:'var(--green-800)'}}>{title}</h3>
            <p style={{margin:0}}>{body}</p>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
}

export default HowItWorks;
